import { QueryKey } from '@tanstack/react-query';

export const getOAuthConsentKey = (oauthRequestId: string): QueryKey => [
  'oauth-consent',
  oauthRequestId,
];
